package fr.frux.shared.domain.model

/**
 * Lot d'arbres a proximite, avec le compte serveur total disponible dans le rayon interroge
 * (#155). [totalAvailable] peut depasser [trees].size : la carte plafonne le lot cote client
 * ([fr.frux.feature.map.MAP_TREE_LIMIT]), et c'est cet ecart qui rend la troncature visible.
 *
 * [isStale] (#62) : vrai seulement pour une emission servie par le cache local perime
 * (stale-while-revalidate, #60) ; toujours faux pour une emission reseau, qui est par definition
 * a jour.
 */
data class NearbyTrees(
    val trees: List<Tree>,
    val totalAvailable: Int,
    val isStale: Boolean = false,
)
